<template>
  <div class="fragment">
    <div class="order-create__row custom-row">
      <div class="custom-col custom-col--33 custom-col--sm-100"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['common_comment'])"></div>
        <TextareaDefault
            :label="$t('common_comment.localization_value.value')"
            v-model="heatTransferVinylItem.data.comment"
        />
      </div>
    </div>
    <div class="order-create__row custom-row">
      <div class="custom-col custom-col--16 custom-col--sm-50"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['common_LengthMM'])"></div>
        <DefaultInput
            :label="$t('common_LengthMM.localization_value.value')"
            :type="'text'"
            v-bind:class="{'ui-no-valid': heatTransferVinylItem.data.Dimensions.validation.dimensionLength}"
            :errorTxt="$t(`${heatTransferVinylItem.data.Dimensions.validationTranslate.dimensionLength}.localization_value.value`)"
            :error="heatTransferVinylItem.data.Dimensions.validation.dimensionLength"
            v-model="heatTransferVinylItem.data.Dimensions.data.dimensionLength"
            @input.native="changeEngravingPrice($event, 'length')"
            @change="calculateHeatTransferVinylPrice"
        />
      </div>
      <div class="custom-col custom-col--16 custom-col--sm-50"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['common_WidthMM'])"></div>
        <DefaultInput
            :label="$t('common_WidthMM.localization_value.value')"
            :type="'text'"
            v-bind:class="{'ui-no-valid': heatTransferVinylItem.data.Dimensions.validation.width}"
            :errorTxt="$t(`${heatTransferVinylItem.data.Dimensions.validationTranslate.width}.localization_value.value`)"
            :error="heatTransferVinylItem.data.Dimensions.validation.width"
            v-model="heatTransferVinylItem.data.Dimensions.data.width"
            @input.native="changeEngravingPrice($event, 'width')"
            @change="calculateHeatTransferVinylPrice"
        />
      </div>
      <div class="custom-col custom-col--16 custom-col--sm-50"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['fbm_engravingCount'])"></div>
        <DefaultInput
            :label="$t('fbm_engravingCount.localization_value.value')"
            :type="'text'"
            v-bind:class="{'ui-no-valid': heatTransferVinylItem.validation.count}"
            :errorTxt="$t(`${heatTransferVinylItem.validationTranslate.count}.localization_value.value`)"
            :error="heatTransferVinylItem.validation.count"
            v-model="heatTransferVinylItem.data.count"
            @input.native="changeEngravingPrice($event, 'count')"
            @change="(val) => {calculateHeatTransferVinylPrice(); $emit('changeQuantity', heatTransferVinylItem.data.customization, val)}"
        />
      </div>
      <div class="custom-col custom-col--16 custom-col--sm-50"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['calculatorEngraving_permanentVinylColor',])"></div>
        <DefaultSelect
            :options="heatTransferVinylColorOptions"
            :label="$t('calculatorEngraving_permanentVinylColor.localization_value.value')"
            :otherValue="'calculatorCustomization'"
            :selected="heatTransferVinylItem.data.color"
            @change="(val) => {heatTransferVinylItem.data.color = val; calculateHeatTransferVinylPrice()}"
        />
      </div>
      <div class="custom-col custom-col--16 custom-col--sm-50"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['fbm_engravingPrice'])"></div>
        <DefaultInput
            :label="$t('fbm_engravingPrice.localization_value.value')"
            :type="'text'"
            :disabled="true"
            v-model="heatTransferVinylItem.data.resultCost"
        />
      </div>
    </div>

    <div
        v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
      <div class="admin-edit" @click="editTranslate(['fbm_engravingAcceptFiles4'])"></div>
      {{ $t('fbm_engravingAcceptFiles4.localization_value.value') }}
    </div>
    <div class="order-create__row custom-row">
      <div class="custom-col position-relative"
           v-if="heatTransferVinylItem.data.File.data.maxCountFiles - Object.keys(heatTransferVinylItem.data.File.data.downloadFiles).length > 0">
        <DropZone class="drop-zone-bg"
                  :parentFiles="heatTransferVinylItem.data.File.data.files"
                  :multiple="true"
                  :maxCount="heatTransferVinylItem.data.File.data.maxCountFiles - heatTransferVinylItem.data.File.data.downloadFiles.length"
                  :maxSize="heatTransferVinylItem.data.File.data.maxSizeFiles"
                  @changeImg="(files, maxSize) => {changeFile(files, maxSize)}"
                  :accept="'/*'"
        />
        <div class="error-field ml-3" v-if="heatTransferVinylItem.data.File.validation.files">
          {{ $t('common_fileIsRequired.localization_value.value') }}
        </div>
      </div>

      <div class="custom-col mt-3"
           v-if="Object.keys(heatTransferVinylItem.data.File.data.downloadFiles).length > 0"
      >
        <div class="custom-row product-img-row">
          <div class="custom-col custom-col--16 custom-col--md-25 custom-col--sm-100"
               v-for="(item, index) in heatTransferVinylItem.data.File.data.downloadFiles"
               :key="index">
            <DownloadFileBlock
                :file="item"
                @removeFile="(id) => {removeFile(id, index)}"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DefaultInput from "@/components/UI/inputs/DefaultInput/DefaultInput";
import DownloadFileBlock from "@/components/coreComponents/DownloadFileBlock/DownloadFileBlock";
import DropZone from "@/components/coreComponents/DropZone/DropZone";
import DefaultSelect from "@/components/UI/selectiones/DefaultSelect/DefaultSelect";
import {FBMMixinsHelper} from "@/mixins/FBMMixins/FBMMixins";
import TextareaDefault from "@/components/UI/textarea/TextareaDefault/TextareaDefault";

export default {
  name: "HeatTransferVinyl",
  components: {TextareaDefault, DefaultSelect, DefaultInput, DownloadFileBlock, DropZone},

  mixins: [FBMMixinsHelper],

  props: {
    FBM: Object,
    heatTransferVinylItem: Object,
    heatTransferVinylColorOptions: Array,
  },
  
  // watch: {
  //   isWarehouseLodz() {
  //     if(this.isWarehouseLodz && this.heatTransferVinylItem.data.customization) {
  //       this.changeCustomization(null)
  //     }
  //   },
  // },

  methods: {

    // changeCustomization(val) {
    //   let oldCustomization = this.heatTransferVinylItem.data.customization
    //   this.heatTransferVinylItem.data.customization = val;
    //   this.calculateHeatTransferVinylPrice();
    //   this.$emit('changeCustomization', oldCustomization, val, this.heatTransferVinylItem.data.count)
    // },

    removeTenths() {
      if(('' + this.heatTransferVinylItem.data.Dimensions.data.dimensionLength).indexOf('.') > -1) this.heatTransferVinylItem.data.Dimensions.data.dimensionLength = this.heatTransferVinylItem.data.Dimensions.data.dimensionLength.split('.')[0]
      if(('' + this.heatTransferVinylItem.data.Dimensions.data.width).indexOf('.') > -1) this.heatTransferVinylItem.data.Dimensions.data.width = this.heatTransferVinylItem.data.Dimensions.data.width.split('.')[0]
      if(('' + this.heatTransferVinylItem.data.count).indexOf('.') > -1) this.heatTransferVinylItem.data.count = this.heatTransferVinylItem.data.count.split('.')[0]
    },

    changeEngravingPrice(event, type = false) {

      if(type) {
        switch (type) {
          case 'length':
            this.heatTransferVinylItem.data.Dimensions.data.dimensionLength = event.target.value.replace(',', '.').replace(/[^0-9.]/g, '')
            break
          case 'width':
            this.heatTransferVinylItem.data.Dimensions.data.width = event.target.value.replace(',', '.').replace(/[^0-9.]/g, '')
            break
          case 'count':
            this.heatTransferVinylItem.data.count = event.target.value.replace(',', '.').replace(/[^0-9.]/g, '')
            break
          default:
            break
        }

        /**
         * Remove Tenths
         */
        this.removeTenths()
      }
    },

    calculateHeatTransferVinylPrice() {
      if(
          (!this.heatTransferVinylItem.data.Dimensions.data.dimensionLength || this.heatTransferVinylItem.data.Dimensions.data.dimensionLength.length === 0) ||
          (!this.heatTransferVinylItem.data.Dimensions.data.width || this.heatTransferVinylItem.data.Dimensions.data.width.length === 0) ||
          (!this.heatTransferVinylItem.data.count || this.heatTransferVinylItem.data.count.length === 0)
      ) {
        return
      }

      let data = {
        // offer: this.heatTransferVinylItem.data.customization ? this.heatTransferVinylItem.data.customization?.id : null,
        length: this.heatTransferVinylItem.data.Dimensions.data.dimensionLength,
        width: this.heatTransferVinylItem.data.Dimensions.data.width,
        quantity: this.heatTransferVinylItem.data.count,
      }

      this.$store.dispatch('getHeatTransferVinylCalcResultInOrder', data).then(response => {
        if(this.getRespData(response)?.rate) {
          this.heatTransferVinylItem.data.resultCost = parseFloat(this.getRespData(response)?.rate).toFixed(2)
        }
      })
    },

    changeFile(files, maxSizeError) {
      this.heatTransferVinylItem.data.File.setFiles(files)

      this.heatTransferVinylItem.data.File.setFilesMaxSizeError(maxSizeError)

      // this.calculateHeatTransferVinylPrice()
    },

    removeFile(id, index){

      let text = {
        title: 'common_AreYouSure',
        txt: '',
        yes: 'common_confirmDelete',
        no: 'common_confirmNo'
      }

      let confirm = () => {

        let fileKey = Object.keys(this.heatTransferVinylItem.data.File.data.downloadFiles[index])[0]
        if(fileKey) {
          this.FBM.data.removedCustomizationFiles.push(this.heatTransferVinylItem.data.File.data.downloadFiles[index][fileKey]?.uuid)
          this.heatTransferVinylItem.data.File.removeDownloadFile(index)
        }


        // this.$store.dispatch('removeUserDocument', id).then(() => {
        //
        //   this.heatTransferVinylItem.data.File.removeDownloadFile(index)
        //   // this.FBM.data.EngravingFile.setDownloadFiles([])
        //
        //   // this.calculateHeatTransferVinylPrice()
        // })

        this.$store.commit('setConfirmDeletePopup', false)
        return true
      }

      this.deleteFunc(text, confirm)


    },
  },

}
</script>

<style scoped>

</style>